import { ChangeEvent, FormEvent, MouseEvent, useEffect, useState } from "react";
import CouponForm from "./components/CouponForm";
import { connect, useSelector } from "react-redux";
import { CouponError, CreateCouponInput } from "../store/actionType";
import { createCoupon, fetchCoupons, resetCoupon } from "../store/action";
import { ApiError } from "components";
import validateCouponForm from "./components/validateCouponForm";
import { CouponGenerationType } from "props/enum";
import { MailInput } from "modules/email_log/store/actionType";
import { CommercialUserProps } from "modules/user_management/commercial_user/user/state/actionType";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps;
const HandleCreateCoupon: React.FC<Props> = ({
  onCreateCoupon,
  onResetCoupon,
  onFetchCoupons,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreateCouponInput>({
    membershipDurationID: "",
    receiverDetail: "",
    generationType: "",
    count: 0,
  });
  const [error, setError] = useState<CouponError>({});
  const [apiError, setApiError] = useState(null);
  const couponState = useSelector(
    (state: any) => state.coupon.genericCouponState
  );
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;

    setFormData((prev) => {
      if (name === "generationType") {
        return {
          ...prev,
          generationType: value,
          count: value === CouponGenerationType.admin ? 1 : 0,
          receiverDetail:
            value === CouponGenerationType.printed ? undefined : "",
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });

    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleReceiverSelect = (user: CommercialUserProps) => {
    setFormData((prev) => ({
      ...prev,
      receiverDetail: user.id.toString(),
      userEmail: user.email,
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    const errors = validateCouponForm(formData);
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }
    const input: CreateCouponInput = {
      membershipDurationID: formData.membershipDurationID.toString(),
      generationType: formData.generationType,
      count: formData.count,
      ...(formData.generationType === CouponGenerationType.admin && {
        receiverDetail: formData.receiverDetail,
        count: 1
      }),
    };

    if (formData.membershipDurationID.trim() !== "") {
      setLoading(true);
      setSubmitted(true);
      await onCreateCoupon(input);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!couponState.isLoading && submitted) {
      if (couponState.error) {
        setApiError(couponState.error);
      } else {
        setApiError(null);
        if (formData.generationType === CouponGenerationType.admin) {
          const sendMailInput: MailInput = {
            to: formData.userEmail ? formData.userEmail : "",
            subject: "Redeem Coupon",
            title: "Redeem Coupon",
            content: `Coupon : ${(
              <strong className="font-bold">
                {couponState.data?.couponDetails?.code
                  ? couponState.data?.couponDetails?.code
                  : "Couldn't get coupon"}{" "}
              </strong>
            )}`,
          };
        }
      }
    }
  }, [couponState.isLoading, couponState.error, submitted]);
  useEffect(() => {
    onResetCoupon();
    onFetchCoupons();

    return () => {
      onResetCoupon();
    };
  }, []);

  return (
    <>
      <CouponForm
        formData={formData}
        formError={error}
        handleChange={handleChange}
        handleSubmit={handleSave}
        loading={loading}
        couponData={couponState.data?.data?.couponDetails}
        onReceiverSelect={handleReceiverSelect}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateCoupon: (input: CreateCouponInput) => dispatch(createCoupon(input)),
  onResetCoupon: () => dispatch(resetCoupon()),
  onFetchCoupons: () => dispatch(fetchCoupons()),
});

export default connect(null, mapDispatchToProps)(HandleCreateCoupon);
